import { render } from "./SupportedFiles.vue?vue&type=template&id=62d6c6f2&ts=true"
import script from "./SupportedFiles.vue?vue&type=script&lang=ts"
export * from "./SupportedFiles.vue?vue&type=script&lang=ts"

import "./SupportedFiles.vue?vue&type=style&index=0&id=62d6c6f2&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__